/**
 * @generated SignedSource<<02b34d7cd12da84bb4e4f3744967257c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CommentElement_element$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ElementBase_element">;
  readonly " $fragmentType": "CommentElement_element";
};
export type CommentElement_element$key = {
  readonly " $data"?: CommentElement_element$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentElement_element">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CommentElement_element",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ElementBase_element"
    }
  ],
  "type": "ElementNode",
  "abstractKey": null
};

(node as any).hash = "3ed2cb568c96c7c3956995d18d0c1ad6";

export default node;
